import { Layout } from "layouts";
// Components
import {HeadingProjectsPartners, ProjectItems} from "@/components/projects-partners";

const ProjectsAndPartners: React.FC = () => {
  return (
    <Layout page="projects-partners">
      <HeadingProjectsPartners />
      <ProjectItems />
    </Layout>
  );
};

export default ProjectsAndPartners;
